import React from "react";
import Modal from "./modal";
import { getString } from "../../utilities";

export default function OKModal({ button = getString("ok"), children = null, close, doShow, title }) {
  const header = title && title.length > 0 ? <div className="modal-content-header">{title}</div> : null;

  return (
    <Modal doShow={doShow} closeOnEscape={close}>
      {header}
      {children}
      <button type="button" className="button-flat-color pt-green" onClick={close}>
        {button}
      </button>
    </Modal>
  );
}
